import { hidePopper } from "@H/custom-select";

export default {
    data() {
        return {
            popperId: null
        };
    },
    mounted() {
        const card = document.querySelector(".card");
        if (card) {
            card.querySelector(".card-body").addEventListener(
                "scroll",
                this.hidePoppers
            );
        } else {
            window.addEventListener("scroll", this.hidePoppers);
        }
    },
    beforeDestroy() {
        if (window.poppers !== null) {
            const popper = window.poppers[`popper-${this.popperId}`];
            popper ? popper.destroy() : null;
            this.popperId = null;
        }

        const card = document.querySelector(".card");
        window.removeEventListener("scroll", this.hidePoppers);
        if (card) {
            card.querySelector(".card-body").removeEventListener(
                "scroll",
                this.hidePoppers
            );
        }
    },
    methods: {
        hidePoppers() {
            const popperKeys = Object.keys(window.poppers);
            if (popperKeys.length > 0) {
                popperKeys.forEach(key => {
                    hidePopper(window.poppers[key]);
                });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/popperManager.js